import { createStore } from 'vuex';

// TODO: проверить зависимости
export default (config) => createStore(config);
